import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import LayOut from "src/layouts/teamEffSurvey/teamEffStartPage";

const Disclaimer = lazy (() => import("src/layouts/teamEffSurvey/components/disclaimer"));

export const teamEffectivenessRoutes = [
    {
        path:"",
        element: (
            <LayOut>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </LayOut>
        ),
        children :[
            {
                path:"teamEffectivenessSurvey",
                index:true,
                element : <Disclaimer/>
            }
        ]
    }
]